export type BlogPostStatus = 'DRAFT' | 'SCHEDULED' | 'PUBLISHED' | 'ARCHIVED'

export const STATUS_META: Record<BlogPostStatus, { label: string; color: string }> = {
  DRAFT: { label: 'Nacrt', color: 'default' },
  SCHEDULED: { label: 'Zakazano', color: 'blue' },
  PUBLISHED: { label: 'Objavljeno', color: 'green' },
  ARCHIVED: { label: 'Arhivirano', color: 'red' },
}

const CYR_LATIN_MAP: Record<string, string> = {
  š: 's', đ: 'dj', ž: 'z', č: 'c', ć: 'c',
  Š: 's', Đ: 'dj', Ž: 'z', Č: 'c', Ć: 'c',
}

/** Serbian-Latin aware slugifier. */
export function slugify(input: string): string {
  return input
    .split('')
    .map((ch) => CYR_LATIN_MAP[ch] ?? ch)
    .join('')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}
